<template id="">
    <aside class="md:min-h-screen flex md:hidden flex-col items-center shadow aside--mobile">
        <ul class="w-full md:mt-20 flex md:block justify-center items-center py-2 py:md-0">
            <li v-if="currentItem" class="px-3">
                <router-link
                        :to="{ name: 'autologin', query: { war_id: currentItem ? currentItem.id : '', serial: currentItem ? currentItem.serial : '' } }"
                        active-class="active"
                        class="nav-router-link flex-col w-16 md:w-12 h-12">
                    <i class="fas fa-tachometer-fast"></i>
                    <span class="text-sm mt-1">
                        Dashboard
                    </span>
                </router-link>
            </li>

            <li v-if="currentItem" class="px-3">
                <router-link
                        :to="{ name: 'bookServiceCall', query: { war_id: currentItem ? currentItem.id : '', serial: currentItem ? currentItem.serial : '' } }"
                        active-class="active"
                        class="nav-router-link flex-col w-16 md:w-12 h-12">
                    <i class="fas fa-wrench"></i>
                    <span class="text-sm mt-1">
                        Service
                    </span>
                </router-link>
            </li>
            <li v-if="currentItem" class="px-3">
                <router-link
                        :to="{ name: 'orderConsumables', query: { war_id: currentItem ? currentItem.id : '', serial: currentItem ? currentItem.serial : '' } }"
                        active-class="active"
                        class="nav-router-link flex-col w-16 md:w-12 h-12">
                    <i class="fas fa-tint"></i>
                    <span class="text-sm mt-1">
                        Order
                    </span>
                </router-link>
            </li>

            <li v-if="currentItem" class="px-3">
                <router-link
                        :to="{ name: 'meterReadings', query: { war_id: currentItem ? currentItem.id : '', serial: currentItem ? currentItem.serial : '' } }"
                        active-class="active"
                        class="nav-router-link flex-col w-16 md:w-12 h-12">
                    <i class="fas fa-print"></i>
                    <span class="text-sm mt-1">
                        Meter
                    </span>
                </router-link>
            </li>
        </ul>
    </aside>
</template>
<script charset="utf-8">
    import Vuex from 'vuex';

    export default {
        name: 'NoUserMobileNav',
        data() {
            return {
                isActive: false
            }
        },
        computed: {
            ...Vuex.mapGetters('equipments', {
                currentItem: 'currentItem'
            }),
        }
    }
</script>

